module.exports = __webpack_public_path__ + "7f0f70a850eac462360ddfc19bfd848e.mp3";